import React from 'react'
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaRegMessage } from "react-icons/fa6";
import { TbBrandGoogleFilled } from "react-icons/tb";

import { FaArrowLeftLong } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import SMSCampaignReport from './SMSCampaignReport';
import RCSCamapignReport from './RCSCamapignReport';
import WhatsAppCampaignReport from './WhatsAppCampaignReport';



function JourneyCampaigns() {

    const [activeTab, setActiveTab] = useState("WhatsAppCampaignReport");

    const tabList = [
        {
            id: "WhatsAppCampaignReport", label: "WhatsApp Campaign Report", icon: <FaWhatsapp />
            , component: <WhatsAppCampaignReport/>
        }
        
    ];
    return (
        <>
            <div className='dark:bg-[#121519] min-h-screen md:pt-[70px] pt-[100px] px-4'>

                <div className='border-b-[1px] border-[#cfcdcd] pb-1 flex items-center gap-2  '>
                    <Link to='/Report'>
                        <FaArrowLeftLong className='text-[20px] dark:text-[#fff]' />
                    </Link>
                    <div>
                        <h1 className='text-[#000] font-semibold text-[20px] dark:text-[#fff]'>Journey Campaign Reports</h1>
                        <div className='text-[#454546] dark:text-[#fff] text-[12px] font-semibold flex items-center cursor-pointer'>  <span>Home</span> <IoIosArrowForward /> <span>Journey Campaign Reports</span>  </div>
                    </div>
                </div>
                <div className=' w-[100%] flex gap-1 px-2 pt-4  '>
                    {tabList.map((item, index) =>
                        <button
                            onClick={() => setActiveTab(item.id)}
                            className={` w-[32%] rounded-[5px]  py-2 text-[11px] font-bold flex items-center justify-center gap-1 ${activeTab === item.id ? 'bg-[#37715d] text-[#fff]' : 'bg-[#e0e0e0] text-[#333]'} `} > {item.icon}  <span className='md:block hidden'>{item.label}</span>  </button>
                    )
                    }
                </div>
                <div className="pt-4 px-2 dark:bg-[#121519]">
                    {tabList.find((t) => t.id === activeTab)?.component}
                </div>
            </div>
        </>
    )
}

export default JourneyCampaigns
